export const subjectInfo = [
    {
        subjectInfoNumber: "1",
        subjectInfoTitle: "Whole Numbers",
        subjectInfoText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Turpis in eu mi bibendum neque egestas congue quisque egestas. In fermentum posuere urna nec tincidunt praesent semper feugiat.",
        subjectTopic: "1 of 5 Sub - Topics",
        subjectInfoTopics: [
            {
                subTopic: "Definition of Numbers",
                isDone: true,
                duration: '8m 42s'
            },
            {
                subTopic: "Place Value",
                isDone: false,
                duration: '50m 13s'
            }, {
                subTopic: "Counting: Tens, Hundreds, Thousands",
                isDone: false,
                duration: '12m 42s'
            }, {
                subTopic: "Translating Numbers Written into Figures",
                isDone: false,
                duration: '10m 42s'
            }, {
                subTopic: "Quiz",
                isDone: false,
                isQuiz: true,
                duration: '8m 42s'
            }
        ]
    },
    {
        subjectInfoNumber: "2",
        subjectInfoTitle: "Basic Operations on Whole Numbers: Substraction and Addition",
        subjectInfoText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Turpis in eu mi bibendum neque egestas congue quisque egestas. In fermentum posuere urna nec tincidunt praesent semper feugiat.",
        subjectTopic: "7 Sub - Topics",
        subjectInfoTopics: [
            {
                subTopic: "Definition of Numbers",
                isDone: true,
                duration: '8m 42s'
            },
            {
                subTopic: "Place Value",
                isDone: false,
                duration: '50m 13s'
            }, {
                subTopic: "Counting: Tens, Hundreds, Thousands",
                isDone: false,
                duration: '12m 42s'
            }, {
                subTopic: "Translating Numbers Written into Figures",
                isDone: false,
                duration: '10m 42s'
            }, {
                subTopic: "Quiz",
                isDone: false,
                isQuiz: true,
                duration: '8m 42s'
            }
        ]
    },
    {
        subjectInfoNumber: "3",
        subjectInfoTitle: "Counting in Base Two",
        subjectInfoText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Turpis in eu mi bibendum neque egestas congue quisque egestas. In fermentum posuere urna nec tincidunt praesent semper feugiat.",
        subjectTopic: "3 Sub - Topics",
        subjectInfoTopics: [
            {
                subTopic: "Definition of Numbers",
                isDone: true,
                duration: '8m 42s'
            },
            {
                subTopic: "Place Value",
                isDone: false,
                duration: '50m 13s'
            }, {
                subTopic: "Counting: Tens, Hundreds, Thousands",
                isDone: false,
                duration: '12m 42s'
            }, {
                subTopic: "Translating Numbers Written into Figures",
                isDone: false,
                duration: '10m 42s'
            }, {
                subTopic: "Quiz",
                isDone: false,
                isQuiz: true,
                duration: '8m 42s'
            }
        ]
    },
    {
        subjectInfoNumber: "4",
        subjectInfoTitle: "Whole Numbers",
        subjectInfoText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Turpis in eu mi bibendum neque egestas congue quisque egestas. In fermentum posuere urna nec tincidunt praesent semper feugiat.",
        subjectTopic: "1 of 5 Sub - Topics",
        subjectInfoTopics: [
            {
                subTopic: "Definition of Numbers",
                isDone: true,
                duration: '8m 42s'
            },
            {
                subTopic: "Place Value",
                isDone: false,
                duration: '50m 13s'
            }, {
                subTopic: "Counting: Tens, Hundreds, Thousands",
                isDone: false,
                duration: '12m 42s'
            }, {
                subTopic: "Translating Numbers Written into Figures",
                isDone: false,
                duration: '10m 42s'
            }, {
                subTopic: "Quiz",
                isDone: false,
                isQuiz: true,
                duration: '8m 42s'
            }
        ]
    },
]